//
// GENERATED by KVision
//
package pl.finn.forms.wouip

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class WouipService : IWouipService

object WouipServiceManager : KVServiceManager<WouipService>(WouipService::class) {
    init {
        registerKVisionServiceExceptions()
        bind(IWouipService::nowy, HttpMethod.POST, null)
        bind(IWouipService::edycja, HttpMethod.POST, null)
        bind(IWouipService::sprawdz, HttpMethod.POST, null)
        bind(IWouipService::zapisz, HttpMethod.POST, null)
        bind(IWouipService::podglad, HttpMethod.POST, null)
    }
}
